import React from 'react'
import './TopBar.css'
import logo from './lokalpioniere.svg'
import alarm from './alarm.svg'
import letter from './letter.svg'

import {
    BrowserRouter as Router, 
    Switch, 
    Route, 
    Link
  } from 'react-router-dom';

export default function TopBar(props) {


    const [region, setRegion] = React.useState("Ingolstadt")

    const handleRegionChange = event => {
        setRegion(event.target.value)
    }


    return (
        <>
            <div className="header-container">
                <Link to="/"><img className="header-logo" src={logo}/></Link>
        
                <div className="header-elements">
                    <input className="search" type="text" placeholder="Nach Geschäft, Projekt, oder Stichwort suchen..." />
                    <input className="location" type="text" value={region} onChange={handleRegionChange} placeholder="Wo?" />
                    <button className="search-button" >suchen</button>
                </div>

                <div className="header-profile">
                    <img className="alarm" src={letter}></img>
                    <img className="alarm" src={alarm}></img>
                    <Link to="/profile/xy"><img className="profile-picture" src="https://www.xing.com/image/8_8_5_4e8c52173_23470511_1/tin-stribor-sohn-foto.1024x1024.jpg"></img></Link>
                </div>

            </div>
        </>
    )

}